import { render, staticRenderFns } from "./preorderdetail.vue?vue&type=template&id=1a43914f&scoped=true&"
import script from "./preorderdetail.vue?vue&type=script&lang=js&"
export * from "./preorderdetail.vue?vue&type=script&lang=js&"
import style0 from "./preorderdetail.vue?vue&type=style&index=0&id=1a43914f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a43914f",
  null
  
)

export default component.exports